(function ($) {
    const profileModel = function (profile, $vm, updateHeight, updateDependentList, loadProfile, forceReimbursementPopup, directPayFeatureControlRequest, directPayConsentRequest) {
        updateHeight = typeof updateHeight === 'function' ? updateHeight : function () { };

        const directPayConsentStatuses = $.cdh.enums.directPayConsentStatus;

        $.extend(true, this, initProfile(profile));
        var self = this;
        self.editReimbursementModel = new $.cdh.models.ProfileReimbursementMethodEditPopup(profile, false, updateHeight, loadProfile);

        function initProfile(data) {
            const profile = ko.observable({ viewModel: ko.observable({}), isSameAddress: ko.observable(false), isSameOrEmptyAddress: ko.observable(false) })();
            
            profile.forceReimbursementPopup = forceReimbursementPopup || false;

            //Permissions
            profile.hasPermissionsToEditProfile = $.cdh.helper.hasPermission($.cdh.enums.userPermission.userPermissionUpdateProfileDemographicInformation);
            profile.hasPermissionsToEditEmail = $.cdh.helper.hasPermission($.cdh.enums.userPermission.userPermissionUpdateEmailAddress);
            
            profile.vm = $vm;
            profile.viewModel(data);
            profile.isSameAddress(isAddressesSame(data));
            profile.isSameOrEmptyAddress(profile.isSameAddress() || isShippingAddressEmpty(data));
            profile.email = ko.observable(profile.viewModel().Email);

            const computed = ko.observable({});
            computed.FullName = ko.computed(function () {
                return profile.viewModel().FirstName + " " + profile.viewModel().LastName;
            });
            profile.viewModel(ko.utils.extend(profile.viewModel(), computed));

            profile.updateProfile = updateProfile;
            profile.directPayTooltipId = "tooltip_directpay_status_" + $.cdh.helper.getUniqueID("");
            profile.directPayCanPersist = Object.prototype.hasOwnProperty.call(data, "DirectPayStatus");
            profile.directPayStatus = ko.observable(parseDirectPayStatus(data.DirectPayStatus));
            profile.savedDirectPayStatus = ko.observable(profile.directPayStatus());
            profile.pendingDirectPayStatus = ko.observable(null);
            profile.directPayConsentStatus = ko.observable(profile.directPayStatus()
                ? directPayConsentStatuses.granted
                : directPayConsentStatuses.notSet);
            profile.directPayHoverText = ko.pureComputed(function () {
                const status = normalizeDirectPayConsentStatus(profile.directPayConsentStatus());
                return status === directPayConsentStatuses.notSet ? "NOT SET" : status;
            });
            profile.directPayFeatureControl = ko.observable(null);
            profile.isEmployerEnabled = ko.observable(profile.directPayCanPersist);
            profile.directPayConsentChangeVersion = 0;
            profile.directPayConsentLoadVersion = 0;
            profile.onDirectPayStatusChange = function (data, event) {
                return onDirectPayStatusChange(profile, event);
            };
            if (profile.directPayCanPersist) {
                profile.viewModel().DirectPayStatus = profile.directPayStatus();
            }
            profile.directPayFeatureControlRequest = directPayFeatureControlRequest || new $.cdh.get.profile.directPayFeatureControl();
            profile.directPayConsentRequest = directPayConsentRequest || new $.cdh.get.profile.directPayConsent();
            profile.directPayFeatureControlRequest.state.subscribe(function (state) {
                if (state.hasData) applyDirectPayFeatureControl(profile, state.data);
            });
            profile.directPayConsentRequest.state.subscribe(function (state) {
                if (state.hasData &&
                    profile.directPayConsentLoadVersion === profile.directPayConsentChangeVersion) {
                    applyDirectPayConsent(profile, state.data);
                }
            });
            if (profile.directPayFeatureControlRequest.hasData()) {
                applyDirectPayFeatureControl(profile, profile.directPayFeatureControlRequest.data());
            }
            if (profile.directPayConsentRequest.hasData()) {
                applyDirectPayConsent(profile, profile.directPayConsentRequest.data());
            }
            profile.directPayConsentUpdateRequest = new $.cdh.post.profile.updateDirectPayConsent();
            window.addEventListener("wcp:directpay-status-changed", function (event) {
                profile.directPayConsentChangeVersion += 1;
                const detail = event && event.detail;
                const consent = detail && detail.consent;
                const status = normalizeDirectPayConsentStatus(
                    (consent && consent.status) || (detail && detail.status)
                );
                if (status === directPayConsentStatuses.notSet) return;
                applyDirectPayConsent(profile, { data: consent || { status: status } });
            });
            profile.directPaySubmitText = ko.pureComputed(function () {
                return profile.directPayConsentUpdateRequest.isLoading()
                    ? $.cdh.languageConstant.getConstant('button.saving')
                    : $.cdh.languageConstant.getConstant('button.save');
            });
            profile.editProfileModel = new $.cdh.models.editProfileModel(profile, profile.updateProfile);
            profile.editUserPictureModel = new $.cdh.models.editUserPictureModel(profile,function(){});
            profile.editEmailModel = new $.cdh.models.editEmailModel(profile.viewModel().Email, function (newEmail) {
                loadProfile(); // 	WCP-2462
                profile.email(newEmail);
            }, profile);
            
            profile.profileDeleteAccountModel = new $.cdh.models.profileDeleteAccountModel(function () { });

            profile.changeLanguage = new $.cdh.models.changeLanguage(function () { });
            
            profile.editReimbursementModel = new $.cdh.models.ProfileReimbursementMethodEditPopup(profile, false, updateHeight, loadProfile);
            profile.editReimbursementModel.isProfile = true;

            profile.takeLast4 = takeLast4;

            profile.editLinkText = $.cdh.extensions.profile.ConnectedCacheAvailable(data) ? $.cdh.languageConstant.getConstant('profile.edit-Eligible-for-Connected-Cash') : $.cdh.languageConstant.getConstant('profile.edit')
            recalcWidgetsHeights();

            if (!profile.directPayFeatureControlRequest.hasData() && !profile.directPayFeatureControlRequest.isLoading()) {
                profile.directPayFeatureControlRequest.load();
            }

            return profile;
        }

        self.onEditReimbursementClick = function () {
            if (self.editReimbursementModel.ReimbursementMethod != $.cdh.enums.reimbursementMethod.directDeposit) {
                self.editReimbursementModel.bankAccountInReviewSummary(null);
            }
            self.editReimbursementModel.bankAccountContinueSummary(null);
            self.editReimbursementModel.bankAccountSummary(null);
            self.editReimbursementModel.validationActivated(false);
            self.editReimbursementModel.validationReimbursementActivated(false);
            if (self.editReimbursementModel && typeof self.editReimbursementModel.displayState === "function") {
                self.editReimbursementModel.displayState(self.editReimbursementModel.stateEnum.oobStep);
            }
        };

        function updateProfile(profile, newProfile, onSuccess) {
            if (profile.updateProfileRequest.isLoading())
                return;

            let _isMobileNumberSame = isMobileNumberSame(profile, newProfile);

            profile.updateProfileRequest.load(newProfile.viewModel()).done(function (result) {
                var isSameAddress = isAddressesSame(result);
                var isEmptyAddress = isShippingAddressEmpty(result);

                profile.isSameAddress(isSameAddress);
                profile.isSameOrEmptyAddress(isSameAddress || isEmptyAddress);

                profile.viewModel(ko.utils.extend(newProfile.viewModel(), result));
                if (onSuccess)
                    onSuccess();
                updateHeight();
                recalcWidgetsHeights();
                if (ko.isObservable(updateDependentList)) {
                    updateDependentList(true);
                }
                if (!_isMobileNumberSame) {
                    var updateMobileNumberPopup = $.cdh.languageConstant.getConstant('profile.update-mobile-number');
                    var communicationSettingLink = $.cdh.languageConstant.getConstant('profile.communication-settings');
                    let settings = {
                        title: $.cdh.languageConstant.getConstant('title.mobile-phone-update'),
                        titleVisible: true,
                        message: `<div class="popup-form_hint big-font text-left" >${updateMobileNumberPopup}<a href="/Page/CommunicationsSummary">${communicationSettingLink}</a></div>`,
                        okVisible: false,
                        cancelVisible: true,
                        cancelText: $.cdh.languageConstant.getConstant('button.close')
                    };
                    
                    $.cdh.helper.alert2(settings);
                }
            });
        }

        function onDirectPayStatusChange(currentProfile, event) {
            const requestedStatus = event && event.target
                ? event.target.checked
                : !currentProfile.savedDirectPayStatus();
            const savedStatus = currentProfile.savedDirectPayStatus();

            if (currentProfile.pendingDirectPayStatus() !== null) {
                currentProfile.directPayStatus(requestedStatus);
                return false;
            }

            if (requestedStatus === savedStatus) {
                return true;
            }

            currentProfile.pendingDirectPayStatus(requestedStatus);
            currentProfile.directPayStatus(requestedStatus);

            $.cdh.helper.alert2({
                title: $.cdh.languageConstant.getConstant('profile.direct-pay-status'),
                message: $.cdh.languageConstant.getConstant(requestedStatus
                    ? 'profile.direct-pay-enable-confirmation'
                    : 'profile.direct-pay-disable-confirmation'),
                okText: $.cdh.languageConstant.getConstant('button.save'),
                cancelText: $.cdh.languageConstant.getConstant('button.cancel'),
                buttonsBlockCssClass: 'directpay-status-confirm-buttons',
                isImpersonated: $.cdh.user.impersonated,
                okAttrs: $.cdh.user.impersonated ? { disabled: 'disabled' } : {},
                okCallback: function () {
                    saveDirectPayStatus(currentProfile);
                },
                cancelCallback: function () {
                    cancelDirectPayStatus(currentProfile);
                }
            });
            setTimeout(function () {
                bindDirectPayStatusSaveButton(currentProfile);
            }, 0);

            return true;
        }

        function bindDirectPayStatusSaveButton(currentProfile) {
            const buttonsBlock = $('.directpay-status-confirm-buttons').last();
            const okButton = buttonsBlock.find('.js-ok');
            const cancelButton = buttonsBlock.find('.js-cancel');

            if (!okButton.length) {
                return;
            }

            const updateButton = function () {
                const isSaving = currentProfile.directPayConsentUpdateRequest.isLoading();
                const buttonText = currentProfile.directPaySubmitText();

                okButton.prop('disabled', isSaving || $.cdh.user.impersonated);
                cancelButton.prop('disabled', isSaving);
                okButton.find('.btn__text').text(buttonText).attr('title', buttonText);
            };

            updateButton();

            okButton.off('click').on('click', function () {
                const saveRequest = saveDirectPayStatus(currentProfile);
                updateButton();

                if (saveRequest) {
                    saveRequest.always(function () {
                        updateButton();
                        $('#alert-message').length ? $('#alert-message').remove() : $.magnificPopup.close();
                    });
                }

                return false;
            });
        }

        function applyDirectPayConsent(currentProfile, consent) {
            const consentData = getDirectPayConsentData(consent);
            const status = normalizeDirectPayConsentStatus(consentData && consentData.status);
            const isGranted = status === directPayConsentStatuses.granted;

            currentProfile.directPayConsentStatus(status);
            commitDirectPayStatus(currentProfile, isGranted);
        }

        function getDirectPayConsentData(consent) {
            // The portal endpoint returns the consent data directly, while some
            // API gateways return the same payload under a data property.
            if (consent && consent.data && typeof consent.data === "object") {
                return consent.data;
            }

            return consent;
        }

        function applyDirectPayFeatureControl(currentProfile, featureControl) {
            currentProfile.directPayFeatureControl(featureControl);
            currentProfile.isEmployerEnabled(isDirectPayEmployerEnabled(featureControl));
            if (currentProfile.isEmployerEnabled() &&
                !currentProfile.directPayConsentRequest.hasData() &&
                !currentProfile.directPayConsentRequest.isLoading()) {
                currentProfile.directPayConsentLoadVersion = currentProfile.directPayConsentChangeVersion;
                currentProfile.directPayConsentRequest.load();
            }
            updateHeight();
            recalcWidgetsHeights();
        }

        function isDirectPayEmployerEnabled(featureControl) {
            const configuredStates = featureControl && featureControl.configuredStates;

            return !!(featureControl &&
                featureControl.effectiveState &&
                featureControl.effectiveState.enabled === true) ||
                !!(configuredStates &&
                    configuredStates.global &&
                    configuredStates.global.enabled === true &&
                    configuredStates.admin &&
                    configuredStates.admin.enabled === true &&
                    configuredStates.employer &&
                    configuredStates.employer.enabled === true);
        }

        function normalizeDirectPayConsentStatus(status) {
            const normalized = (status || directPayConsentStatuses.notSet)
                .toString()
                .trim()
                .replace(/[\s-]+/g, "_")
                .toUpperCase();

            if (normalized === directPayConsentStatuses.granted ||
                normalized === directPayConsentStatuses.denied ||
                normalized === directPayConsentStatuses.notSet) {
                return normalized;
            }

            return directPayConsentStatuses.notSet;
        }

        function saveDirectPayStatus(currentProfile) {
            const requestedStatus = currentProfile.pendingDirectPayStatus();

            if (requestedStatus === null || currentProfile.directPayConsentUpdateRequest.isLoading()) {
                return;
            }

            const consentStatus = requestedStatus
                ? directPayConsentStatuses.granted
                : directPayConsentStatuses.denied;

            return currentProfile.directPayConsentUpdateRequest.load({ status: consentStatus })
                .done(function (result) {
                    const consentResult = result || { status: consentStatus };
                    currentProfile.directPayConsentRequest.setData(consentResult);
                    window.dispatchEvent(new CustomEvent("wcp:directpay-status-changed", {
                        detail: { consent: getDirectPayConsentData(consentResult) }
                    }));
                })
                .fail(function () {
                    cancelDirectPayStatus(currentProfile);
                });
        }

        function cancelDirectPayStatus(currentProfile) {
            currentProfile.pendingDirectPayStatus(null);
            currentProfile.directPayStatus(currentProfile.savedDirectPayStatus());
            if (currentProfile.directPayCanPersist) {
                currentProfile.viewModel().DirectPayStatus = currentProfile.savedDirectPayStatus();
            }
        }

        function commitDirectPayStatus(currentProfile, status) {
            currentProfile.pendingDirectPayStatus(null);
            currentProfile.savedDirectPayStatus(status);
            currentProfile.directPayStatus(status);
            if (currentProfile.directPayCanPersist) {
                currentProfile.viewModel().DirectPayStatus = status;
            }
            updateHeight();
        }

        function isAddressesSame(data) {
            return data.ShippingAddress1 === data.Address1 &&
                data.ShippingAddress2 === data.Address2 &&
                data.ShippingAddressCity === data.City &&
                data.ShippingAddressState === data.State &&
                data.ShippingAddressZip === data.Zip &&
                data.ShippingAddressCountry === data.Country;
        }

        function isMobileNumberSame(profile, newProfile) {
            return profile.viewModel().MobileNumber === newProfile.viewModel().MobileNumber();
        }

        function isShippingAddressEmpty(data) {
            return !data.ShippingAddress1 &&
                !data.ShippingAddress2  &&
                !data.ShippingAddressCity &&
                !data.ShippingAddressState &&
                !data.ShippingAddressZip;
        }

        function takeLast4(text) {
            return text ? ko.unwrap(text).slice(-4) : "";
        }
        recalcWidgetsHeights();

        function parseDirectPayStatus(value, defaultValue) {
            if (value === undefined || value === null || value === "") {
                return !!defaultValue;
            }

            if (typeof value === "string") {
                return value.toLowerCase() === "true";
            }

            return !!value;
        }
    }

    $.extend(true, $, {
        cdh: {
            models: {
                Profile: profileModel
            }
        }
    });

})(jQuery);
